export default [
  {
    path: '',
    name: 'customer list',
    component: () => import('@/views/app/customer/list/page-list.vue'),
    meta: { title: 'Daftar Pelanggan' },
  },
]
